<template>
    <div class="info-card">
        <div :class="`card-content member-0${ userLevel } fix`">
            <div class="user-level l fix">
                <i :class="`icon icon-member icon-member-0${userLevel} l`"></i>
                <div class="rank-text l">
                    <div class="wel-text">尊敬的：{{ customerInfo.fullName }}</div>
                    <h3>{{userLevelText}}</h3>
                </div>
            </div>
            <div class="welfare-list l">
                <div class="welfare-tip">享受{{ privilegeList.length }}项福利</div>
                <ul class="fix">
                    <li v-for="(item, index) in privilegeList.slice(0, 5)" :key="index">
                        <a href="javascript: void(0)" @click="showWelfare(item.id)">
                            <div class="icon-wrap">
                                <img class="icon" :src="item.pcIcon" :alt="item.name">
                                <div class="item-tip" v-bind:class="{maxWidth: userLevel !== 1}" v-if="index === 0">{{userLevel === 1 ? '$50' : '95折'}}</div>
                            </div>
                            <div class="item-des"><span>{{item.name}}</span></div>
                        </a>
                    </li>
                    <li>
                        <router-link tag="a" to="/member/welfare">
                            <div class="icon-wrap">
                                <div class="more-welfare">
                                    <p>更多</p>
                                    <div class="dots">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                            <div class="item-des"><span>全部福利</span></div>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="rank-box l">
                <div class="rank-tip" v-if="userLevel !== 4">距升级Lv{{ userLevel + 1 }}还差 : <span>{{ customerInfo.validShipCount }}次出行</span><a class="btn-item btn-up-level" href="/Rccl.Cruise/CruiseSearch/Search">立即升级</a></div>
                <div class="rank-tip" v-else>距保级还差 : <span>1次出行</span><a class="btn-item btn-up-level" href="/Rccl.Cruise/CruiseSearch/Search">立即预订</a></div>
                <div class="expire-date">等级结算日 : <span>{{timeFormat(customerInfo.levelExpireDate)}}</span></div>
            </div>
        </div>
        <div class="welfare-layer" v-if="welfareShow">
            <div class="content-wrap">
                <div class="layer-title">
                    <div class="icon icon-welfare">
                        <img :src="privilege.outBlackIcon" :alt="privilege.name" :title="privilege.name">
                    </div>
                    <span>{{privilege.name}}</span>
                </div>
                <div class="layer-detail">
                    <ul>
                        <li>
                            <div class="item-title">福利内容</div>
                            <div class="item-detail" v-html="privilege.content"></div>
                        </li>
                        <li>
                            <div class="item-title">使用说明</div>
                            <div class="item-detail" v-html="privilege.useDirections"></div>
                        </li>
                        <li>
                            <div class="item-title">福利规则</div>
                            <div class="item-detail" v-html="privilege.rule"></div>
                        </li>
                    </ul>
                </div>
                <div class="btn-wrap" v-if="privilege.immediatelyUseFlag && checkType(privilege.type, userLevel)">
                    <a class="btn-item btn-use" :href="privilege.immediatelyUseLink">立即使用</a>
                </div>
                <a class="btn-item btn-close" href="javascript: void(0)" @click="closeWelfareLayer"></a>
            </div>
        </div>
    </div>
</template>

<script>
    import { dateFormat } from '@/libs/tools'
    import axios from '@/libs/api.request'
    export default {
        name: 'InfoCard',
        props: ['info', 'list'],
        data () {
            return {
                customerInfo: {},
                userLevel: 1,
                userLevelText: '',
                privilegeList: [],
                privilege: {},
                welfareShow: false,
            }
        },
        watch: {
            'info': function () {
                this.updateInfo()
            },
            'list': function () {
                this.updateList()
            }
        },
        methods: {
            updateInfo () {
                let info = this.info
                this.customerInfo = info
                this.userLevel = this.getLevel(info.userLevel)
                this.userLevelText = info.userLevel
            },
            updateList () {
                this.privilegeList = this.list
            },
            getLevel (userLevelText) {
                switch (userLevelText) {
                    case '初级会员':
                        return 1
                    case '高级会员':
                        return 2
                    case '精英会员':
                        return 3
                    case '卓越会员':
                        return 4
                }
            },
            timeFormat (timestamp) {
                let time = new Date(timestamp)
                return dateFormat(time, 'YYYY.MM.DD')
            },
            showWelfare (id) {
                this.getPrivilegeById(id)
                    .then(res => {
                        this.welfareShow = true
                        window.console.log(res)
                        this.privilege = res
                    })
            },
            closeWelfareLayer () {
                this.welfareShow = false
                this.privilege = {}
            },
            checkType (type, userLevel) {
                if (type === 0 || type === 1 && userLevel === 1 || type === 2 && userLevel !== 1) return true
            },
            getPrivilegeById (Id) {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/Privilege/ApiGetPrivlegeById',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            Id
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .info-card{
        height: 106px;
        background-color: #fff;
        .card-content{
            .user-level{
                width: 300px;
                padding-left: 25px;
                padding-top: 15px;
                .icon{
                    display: block;
                    width: 78px;
                    height: 78px;
                }
                .rank-text{
                    padding-left: 15px;
                    padding-top: 12px;
                    .wel-text{
                        line-height: 20px;
                    }
                    h3{
                        font-size: 26px;
                        line-height: 36px;
                    }
                }
            }
            .welfare-list{
                width: 326px;
                padding-top: 16px;
                .welfare-tip{
                    width: 100px;
                    margin: 0 auto;
                    line-height: 20px;
                    position: relative;
                    text-align: center;
                    &::before, &::after{
                        content: "";
                        display: block;
                        position: absolute;
                        top: 50%;
                        width: 110px;
                        height: 1px;
                    }
                    &::before{
                        left: -113px;
                    }
                    &::after{
                        right: -113px;
                    }
                }
                ul{
                    padding-top: 7px;
                    text-align: center;
                    li {
                        display: inline-block;
                        position: relative;
                        width: 46px;
                        height: 46px;
                        margin-right: 10px;
                        border-radius: 50%;
                        font-size: 0;
                        &:last-child {
                            margin-right: 0;
                        }
                        .icon-wrap{
                            position: relative;
                            height: 46px;
                            font-size: 0;
                            text-align: center;
                            &::before{
                                content: "";
                                display: inline-block;
                                vertical-align: middle;
                                width: 0;
                                height: 100%;
                            }
                            .icon{
                                display: inline-block;
                                vertical-align: middle;
                                width: 86%;
                            }
                            .item-tip{
                                position: absolute;
                                right: -14px;
                                top: 0;
                                z-index: 9;
                                padding: 0 4px;
                                background-color: #f00;
                                border-radius: 8px;
                                font-size: 12px;
                                color: #fff;
                                line-height: 16px;
                            }
                            .more-welfare{
                                display: inline-block;
                                vertical-align: middle;
                                p{
                                    font-size: 12px;
                                    line-height: 17px;
                                }
                                .dots{
                                    padding-top: 2px;
                                    font-size: 0;
                                    span{
                                        display: inline-block;
                                        width: 4px;
                                        height: 4px;
                                        margin: 0 1px;
                                        border-radius: 50%;
                                    }
                                }
                            }
                        }
                        .item-des{
                            display: none;
                            position: absolute;
                            left: 50%;
                            top: 48px;
                            height: 28px;
                            padding: 0 14px;
                            border-radius: 3px;
                            transform: translateX(-50%);
                            -webkit-transform: translateX(-50%);
                            -moz-transform: translateX(-50%);
                            -o-transform: translateX(-50%);
                            -ms-transform: translateX(-50%);
                            &::before{
                                content: "";
                                display: block;
                                position: absolute;
                                left: 50%;
                                top: -4px;
                                width: 0;
                                height: 0;
                                margin-left: -4px;
                                border-left: transparent solid 4px;
                                border-right: transparent solid 4px;
                            }
                            span{
                                white-space: nowrap;
                                font-size: 12px;
                                line-height: 28px;
                                color: #fff;
                            }
                        }
                        &:hover{
                            .item-des{
                                display: block;
                            }
                        }
                    }
                }
            }
            .rank-box{
                padding-left: 56px;
                padding-top: 27px;
                line-height: 22px;
                color: #747d80;
                span{
                    color: #ffa70d;
                }
                .btn-up-level{
                    display: inline-block;
                    width: 86px;
                    height: 22px;
                    margin-left: 7px;
                    background-color: #fbc500;
                    border-radius: 11px;
                    color: #282b2c;
                    font-size: 12px;
                    text-align: center;
                    line-height: 22px;
                }
                .expire-date{
                    padding-top: 12px;
                }
            }
            &.member-01{
                .user-level{
                    .icon-member{
                        background: url("../../assets/images/member_01.png");
                    }
                    .rank-text{
                        h3{
                            color: #3a5d9b;
                        }
                    }
                }
                .welfare-list{
                    .welfare-tip{
                        color: #77a7e3;
                        &::before, &::after{
                            background-color: #77a7e3;
                        }
                    }
                    li{
                        border: #77a7e3 solid 1px;
                        .more-welfare{
                            p{
                                color: #77a7e3;
                            }
                            .dots{
                                span{
                                    background-color: #77a7e3;
                                }
                            }
                        }
                        .item-des{
                            background-color: #77a7e3;
                            &::before{
                                border-bottom: #77a7e3 solid 4px;
                            }
                        }
                    }
                }
            }
            &.member-02{
                .user-level{
                    .icon-member{
                        background: url("../../assets/images/member_02.png");
                    }
                    .rank-text{
                        h3{
                            color: #5c6376;
                        }
                    }
                }
                .welfare-list{
                    .welfare-tip{
                        color: #939aab;
                        &::before, &::after{
                            background-color: #939aab;
                        }
                    }
                    li{
                        border: #939aab solid 1px;
                        .more-welfare{
                            p{
                                color: #939aab;
                            }
                            .dots{
                                span{
                                    background-color: #939aab;
                                }
                            }
                        }
                        .item-des{
                            background-color: #939aab;
                            &::before{
                                border-bottom: #939aab solid 4px;
                            }
                        }
                    }
                }
            }
            &.member-03{
                .user-level{
                    .icon-member{
                        background: url("../../assets/images/member_03.png");
                    }
                    .rank-text{
                        h3{
                            color: #8e5543;
                        }
                    }
                }
                .welfare-list{
                    .welfare-tip{
                        color: #ca9170;
                        &::before, &::after{
                            background-color: #ca9170;
                        }
                    }
                    li{
                        border: #ca9170 solid 1px;
                        .more-welfare{
                            p{
                                color: #ca9170;
                            }
                            .dots{
                                span{
                                    background-color: #ca9170;
                                }
                            }
                        }
                        .item-des{
                            background-color: #ca9170;
                            &::before{
                                border-bottom: #ca9170 solid 4px;
                            }
                        }
                    }
                }
            }
            &.member-04{
                .user-level{
                    .icon-member{
                        background: url("../../assets/images/member_04.png");
                    }
                    .rank-text{
                        h3{
                            color: #a78856;
                        }
                    }
                }
                .welfare-list{
                    .welfare-tip{
                        color: #bb9151;
                        &::before, &::after{
                            background-color: #bb9151;
                        }
                    }
                    li{
                        border: #bb9151 solid 1px;
                        .more-welfare{
                            p{
                                color: #bb9151;
                            }
                            .dots{
                                span{
                                    background-color: #bb9151;
                                }
                            }
                        }
                        .item-des{
                            background-color: #bb9151;
                            &::before{
                                border-bottom: #bb9151 solid 4px;
                            }
                        }
                    }
                }
            }
        }
        .welfare-layer{
            position: fixed;
            left: 0;
            top: 0;
            z-index: 99;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.5);
            .content-wrap {
                position: absolute;
                left: 50%;
                top: 50%;
                width: 800px;
                padding: 20px 36px;
                margin-left: -275px;
                border-radius: 3px;
                background-color: #fff;
                box-shadow: 0 0 12px rgba(46, 65, 80, 0.17);
                -webkit-box-shadow: 0 0 12px rgba(46, 65, 80, 0.17);
                -moz-box-shadow: 0 0 12px rgba(46, 65, 80, 0.17);
                -o-box-shadow: 0 0 12px rgba(46, 65, 80, 0.17);
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                -o-transform: translateY(-50%);
                -ms-transform: translateY(-50%);
                .layer-title{
                    padding-bottom: 10px;
                    border-bottom: #fac400 solid 1px;
                    .icon-welfare{
                        display: inline-block;
                        vertical-align: middle;
                        position: relative;
                        width: 54px;
                        height: 54px;
                        background-color: #fac400;
                        border-radius: 27px;
                        img{
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            width: 46px;
                            margin-left: -23px;
                            margin-top: -23px;
                        }
                    }
                    span{
                        display: inline-block;
                        vertical-align: middle;
                        padding-left: 8px;
                        font-size: 24px;
                        color: #fac400;
                    }
                }
                .layer-detail{
                    padding-top: 16px;
                    padding-bottom: 10px;
                    ul{
                        li{
                            margin-bottom: 34px;
                            &:last-child{
                                margin-bottom: 0;
                            }
                            .item-title{
                                margin-bottom: 3px;
                                font-size: 22px;
                                line-height: 32px;
                            }
                            .item-detail{
                                color: #747d80;
                                line-height: 20px;
                            }
                        }
                    }
                }
            }
        }
        .btn-close{
            position: absolute;
            right: 10px;
            top: 10px;
            width: 29px;
            height: 29px;
            background: url("../../assets/images/close.png") no-repeat center center #d3dadd;
            background-size: 16px 16px;
            border-radius: 50%;
        }
    }
</style>
